export default "__VITE_ASSET__7ee2841a__"